export default __webpack_public_path__ + "static/media/3.e01e47b3.png";